import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import * as ProductTileProductMapper from "@/services/tracking/mappers/productTileProduct.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: ProductImpressionTrackingInfo) => {
    const event: TypedAnalyticsEvent<ProductImpressionTrackingInfo> = {
        event: EventType.ProductImpression,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackProductTile = (
    product: Product<ProductFieldSet.ProductTile>,
    list?: string,
    placement?: number
) => {
    const trackingInfo: ProductImpressionTrackingInfo = {
        ...ProductTileProductMapper.toProductImpression(product),
        list: list,
        placement: placement
    };

    track(trackingInfo);
};
